import React from 'react';

import PreventDrop from 'components/PreventDrop';
import styles from './styles.module.scss';

interface Props {
  position: number;
}

const LayoutPreventDrop: React.FC<Props> = ({ position }) => (
  <div
    className={styles.layoutPreventDrop}
    style={{ order: position }}
  >
    <PreventDrop />
  </div>
);

export default LayoutPreventDrop;
